import httpClient from './httpClient'

export default {
  async createFunnel(body) {
    let ret = await httpClient.post('/funnels/create', body)
    return ret
  },
  async addVideosToFunnel(funnelId, videos) {
    let ret = await httpClient.post('/funnels/add_videos', {
      id: funnelId,
      videos: videos,
    })
    return ret
  },
  async getAllFunnels() {
    let ret = await httpClient.get('/funnels/get_all')
    return ret
  },

  async getFunnel(funnelId) {
    let ret = await httpClient.get(`/funnels/get/${funnelId}`)
    return ret
  },
  async renameFunnel(funnel) {
    let ret = await httpClient.put(`/funnels/update/${funnel.id}`, funnel)
    return ret
  },
  async deleteFunnel(funnelId) {
    let ret = await httpClient.delete(`/funnels/delete/${funnelId}`)
    return ret
  },

  async removeVideosFromFunnel(funnelId, videos) {
    let ret = await httpClient.delete('/funnels/remove_videos', {
      data: {
        id: funnelId,
        videos: videos,
      },
    })
    return ret
  },
}
